import { isUndefined, filter } from 'lodash';
import { compose, withState, withHandlers, withProps } from 'recompose';

export default compose(
  withState('selectedCategory', 'setCategory'),
  withHandlers({
    resetCategory: ({ setCategory }) => () => setCategory(),
  }),
  withProps(
    ({ services, selectedCategory }) => ({
      services: isUndefined(selectedCategory) ?
        services :
        filter(services, { serviceCategoryId: selectedCategory }),
    })
  ),
);



// WEBPACK FOOTER //
// ./src/app/services/hoc/categoryFilter.js